import { Stack, Box, Text, SlideFade } from '@chakra-ui/react';
import { PROTECTED_PATHS } from '../../app/constants';
import Container from '../../components/Container';
import Footer from '../../components/footer';
import Header from '../../components/Header';
import { RequestTypeCard } from './components/RequestTypeCard';
import { TbBriefcase } from 'react-icons/tb';
import { AiOutlineCar } from 'react-icons/ai';
import { BsPeople } from 'react-icons/bs';
import { transition } from '../..';

const SpecialGuestRequest = () => {
  const { PARTY_EVENT, VEHICLES, CONTRACTOR_ARTISAN } = PROTECTED_PATHS;
  return (
    <SlideFade in={true} offsetX='-1000px' transition={{ ...transition }}>
      <Stack>
        <Box shadow='sm'>
          <Container>
            <Header menu />
          </Container>
        </Box>
        <Container>
          <Stack spacing='8'>
            <Text pt='3' fontSize='1.2rem' textAlign='center'>
              Choose Type Special Request
            </Text>
            <RequestTypeCard
              to={CONTRACTOR_ARTISAN}
              icon={<TbBriefcase size={20} />}
              heading='Contractor / Artisan'
              text='Invite skilled professionals like contractors and artisans of all kinds to your estate.'
            />
            <RequestTypeCard
              to={VEHICLES}
              icon={<AiOutlineCar size={20} />}
              heading='Vehicles'
              text='Get clearance for vehicles coming into the estate from our estate managers.'
            />
            <RequestTypeCard
              to={PARTY_EVENT}
              icon={<BsPeople size={20} />}
              heading='Party/event'
              text='Request approval from your estate managers for your Events and Parties..'
            />
          </Stack>
        </Container>
        <Footer />
      </Stack>
    </SlideFade>
  );
};

export default SpecialGuestRequest;
